import { PromoCode, PromoCodeType } from '@src/@data/types/promoCodes';

export enum PromoCodeStatus {
  Pending = 'pending',
  Active = 'active',
  Used = 'used',
  Expired = 'expired',
}

export interface PromoCodeState {
  type: PromoCodeStatus;
  label: string;
  color: string;
  cancellable: boolean;
  sortOrder: number;
}

export const PromoCodeStates: Record<PromoCodeStatus, PromoCodeState> = {
  pending: {
    type: PromoCodeStatus.Pending,
    label: 'promo_codes_state_pending',
    color: 'info',
    cancellable: true,
    sortOrder: 0,
  },
  active: {
    type: PromoCodeStatus.Active,
    label: 'promo_codes_state_active',
    color: 'success',
    cancellable: true,
    sortOrder: 1,
  },
  used: {
    type: PromoCodeStatus.Used,
    label: 'promo_codes_state_used',
    color: 'primary',
    cancellable: false,
    sortOrder: 2,
  },
  expired: {
    type: PromoCodeStatus.Expired,
    label: 'promo_codes_state_expired',
    color: 'secondary',
    cancellable: false,
    sortOrder: 3,
  },
};

export function ResolveStateForPromoCode(
  code: Pick<PromoCode, 'activeFrom' | 'activeTill' | 'useCount' | 'useLimit'> &
    Partial<Pick<PromoCode, 'type'>>
): PromoCodeState {
  const today = new Date();
  const from = new Date(code.activeFrom);
  const till = new Date(code.activeTill);

  if (
    (!code.type ||
      [PromoCodeType.CountLimit, PromoCodeType.SingleUse].includes(
        code.type
      )) &&
    !!code.useCount &&
    !!code.useLimit &&
    code.useCount > 0 &&
    code.useLimit > 0 &&
    code.useCount >= code.useLimit
  ) {
    return PromoCodeStates.used;
  }
  if (today > till) {
    return PromoCodeStates.expired;
  }
  if (today < from) {
    return PromoCodeStates.pending;
  }
  return PromoCodeStates.active;
}

export const comparePromoCodeStatus = (
  p1: PromoCode,
  p2: PromoCode
): number => {
  const s1 = ResolveStateForPromoCode(p1);
  const s2 = ResolveStateForPromoCode(p2);
  return s1.sortOrder - s2.sortOrder;
};
